/** 该文件夹下的其他目录没用到了 ，可删 */
import React, { useEffect, useState, useMemo } from 'react';
import '@/pages/intelligence/assets/scss/TopCharts/MobileGames/components/Stats.scss';
import { Segment } from 'tea-component';
import { buriedPointGame } from '@/pages/home/utils/buriedPoint';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import { useDispatch, history, connect, getLocale } from 'umi';
import {
  getStatsPageLogMes,
  getCountroesPageLogMes,
} from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/_config';
import MscienceIcon from '@/pages/intelligence/assets/svg/dataSource/mscience-bg.svg';
import Npdicon from '@/pages/intelligence/assets/svg/dataSource/npd-icon.svg';
// import NewzooIcon from '@/pages/home/assets/svg/dataSource/databarin.svg';
import newzoowhite from '@/pages/intelligence/assets/svg/dataSource/action-theme.svg';
// import NewzooIcon from '@/pages/intelligence/assets/svg/dataSource/newzoo-bg.svg';
import NewzooIcon from '@/pages/intelligence/assets/svg/dataSource/databarin-gray.svg';
import SelectChoice from '@/pages/intelligence/components/SelectCompoenet/SelectChoice';
import IconDom from '@/pages/intelligence/components/SelectCompoenet/ItemDom/IconDom';
// import JapanSalesicon from '@/pages/intelligence/assets/svg/dataSource/japanSales.svg';
import SourceExplanation from '@/pages/intelligence/components/SummaryCard/components/SourceExplanation';
// import JapanSales from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/JapanSales';
import NewzooMetrics from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/NewzooMetrics';
import {
  steamSalesDetailList,
  newzooMetricsDetail,
} from '@/pages/intelligence/pages/TopCharts/_config/metricOptions';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { LANGUAGE_CN } from '@home/_config/config';
import DigitalRevenue from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/PCUPhysicalDigital/Pages/DigitalRevenue';
import PhysicalRevenue from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/PCUPhysicalDigital/Pages/PhysicalRevenue';
import GSDData from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/PCUPhysicalDigital/Pages/GSDData';
import PCU from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/PCUPhysicalDigital/Pages/PCU';
import GSDIcon from '@/pages/intelligence/assets/svg/dataSource/gsd-icon.svg';
import useGSDOptions from '@intelligence/pages/TopCharts/_hooks/useGSDOptions';
// import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import useSummarySourceState from '@/pages/intelligence/components/SummaryCard/useSummarySourceState';
import SummaryCard from '@/pages/intelligence/components/SummaryCard';
import { getIfShowSourceExplanation } from '@/pages/intelligence/utils/topchartsUtils';

export default function ConsoleStats(props: any) {
  const {
    gameId,
    tabType = 'stats',
    activeId,
    entityType,
    moduleName,
    activeSegment,
    setActiveSegment,
    // hasJapanSales,
    getRadioOptionsTips,
  } = props;
  // Famitsu/Japan Sales is temporarily unavailable in Intelligence pages.
  const hasJapanSales = false;

  const locale = getLocale();
  const isCN = locale === LANGUAGE_CN;
  // const { resetDetailFilterExtend } = useFilterExtend({});

  const subOptionsList = {
    newzooMetrics: { list: newzooMetricsDetail, svg: NewzooIcon },
  } as any;

  const subNewzooValues = newzooMetricsDetail?.map((item: any) => {
    return item.value;
  });
  const subSteamSalesValues = steamSalesDetailList?.map((item: any) => {
    return item.value;
  });

  const { formatMessage } = useIntlExtend();

  const {
    // GSD options集合 接口loading
    loading: gsdOptionsLoading,
    // GSD segment的options集合
    segments: gsdSegments,
    // GSD device的options集合（级联）
    devices: gsdDevices,
    // GSD device的options集合（扁平化）
    devicesFlatten: gsdDevicesFlatten,
  } = useGSDOptions();

  const mainOptionList = [
    {
      text: formatMessage({ id: `dbi_digital_revenue` }),
      value: 'digitalRevenue',
      svg: MscienceIcon,
    },
    {
      text: formatMessage({ id: `dbi_metric_gsd_sales_date` }),
      value: 'gsd',
      svg: GSDIcon,
    },
    {
      text: formatMessage({ id: `dbi_physical_revenue` }),
      value: 'physicalRevenue',
      svg: Npdicon,
    },
    // Famitsu/Japan Sales is temporarily unavailable.
    // {
    //   text: formatMessage({ id: `dbi_japan_sales` }),
    //   value: 'japanSales',
    //   svg: JapanSalesicon,
    // },
    {
      text: formatMessage({ id: `dbi_newzoo_metrics` }),
      value: 'newzooMetrics',
      svg: NewzooIcon,
    },
  ];
  const mainOptionsValues = mainOptionList?.map((item) => {
    return item.value;
  });

  const getMainSegement = (activeSegment: string, hasJapanSales: boolean) => {
    if (subNewzooValues?.includes(activeSegment)) {
      return 'newzooMetrics';
    }
    if (activeSegment === 'japanSales' && !hasJapanSales) {
      return mainOptionsValues[0];
    }
    return mainOptionsValues?.includes(activeSegment)
      ? activeSegment
      : mainOptionsValues[0];
  };

  const [mainSegment, setMainSegment] = useState<string>(
    getMainSegement(activeSegment, hasJapanSales),
  );
  const [subSegment, setSubSegment] = useState<string>(activeSegment);
  // const [activeSegment, setUrlTab] = useState(activeSegment);
  const [loading, setLoading] = useState(true); // 用于给segment, loading时禁用， 也可以存在model中
  const [destroyed, setDestroyed] = useState(false);
  const [optionsDom, setOptionDom] = useState<{ text: any; value: string }[]>(
    [],
  );

  const dispatch = useDispatch();

  const { openSource, handleClickSourceTips } = useSummarySourceState();

  useEffect(() => {
    handlePageLog(mainSegment, gameId);
  }, []);

  const handlePageLog = (tab: string, gameId: string) => {
    const pageLogMes =
      tabType === 'countries'
        ? getCountroesPageLogMes(entityType, tab)
        : getStatsPageLogMes(entityType, tab);
    if (gameId && pageLogMes) {
      buriedPointGame(pageLogMes, gameId);
    }
    // 每次打点的时候，记录当前打点信息用于详情页头部的feedback参数
    recordPageMesForFeedback(pageLogMes);
  };

  const recordPageMesForFeedback = (logMes: any) => {
    dispatch({
      type: `${DBI_TOPCHARTS}/setActivedPageLogMes`,
      payload: logMes,
    });
  };

  const changeUrl = (activeSubTab: string) => {
    history.replace(
      `/intelligence/topCharts/${
        moduleName || 'PCGames'
      }/gamesDetails/${gameId}/${activeId}/${activeSubTab}`,
    );
  };

  useEffect(() => {
    // japanSales是否需要过滤
    const newDom = mainOptionList
      .filter((item) => {
        if (!hasJapanSales) {
          return item.value !== 'japanSales';
        }
        return true;
      })
      .map((item) => {
        const svgTemp =
          mainSegment == 'newzooMetrics' && item?.value == 'newzooMetrics'
            ? newzoowhite
            : item?.svg;
        const itemTemp = {
          ...item,
          svg: svgTemp,
        };
        return {
          value: item.value,
          text: <IconDom data={itemTemp} />,
        };
      });
    setOptionDom(newDom);
  }, [hasJapanSales, mainSegment, locale]);

  const renderSubSegment = (mainSegment: string) => {
    const subOption = subOptionsList[mainSegment];
    if (!Array.isArray(subOption?.list)) {
      return null;
    }
    const { svg } = subOption;
    const optionDom = subOption.list.map((item: any) => {
      return {
        value: item.value,
        text: (
          <IconDom
            data={{ ...item, text: formatMessage({ id: item.text }), svg }}
          />
        ),
      };
    });
    return (
      <SelectChoice
        className="dbi-stats-select-item"
        // className="segment-light retention-segment"
        labelValue="Metrics"
        changeValue={subSegment}
        optionsList={optionDom}
        getSelectMultiple={(value: any) => {
          // setchange1(value);
          setSubSegment(value);
          setActiveSegment(value);
          changeUrl(value);
        }}
        // array={{ size: 'l' }}
        listWidth={isCN ? 270 : 310}
      />
    );
  };

  const PCUPhysicalDigitalComp =
    mainSegment == 'physicalRevenue'
      ? PhysicalRevenue
      : mainSegment == 'digitalRevenue'
      ? DigitalRevenue
      : mainSegment == 'gsd'
      ? GSDData
      : PCU;

  return (
    <div className="dbi-mobile-games-stats">
      <div className="mobile-games-flex">
        <Segment
          className="segment-light games-left"
          value={mainSegment}
          onChange={(value) => {
            let activeSegmentForUrl = value;
            // TODO 有子标签的需要设置默认值
            if (value === 'newzooMetrics') {
              setSubSegment(subNewzooValues[0]);
              activeSegmentForUrl = subNewzooValues[0];
            } else if (value === 'steamSales') {
              setSubSegment(subSteamSalesValues[0]);
              activeSegmentForUrl = subSteamSalesValues[0];
            }
            // Famitsu/Japan Sales is temporarily unavailable.
            // if (value === 'japanSales') {
            //   resetDetailFilterExtend();
            // }
            setActiveSegment(activeSegmentForUrl);
            setMainSegment(value);
            handlePageLog(value, gameId);
            setDestroyed(true);
            setTimeout(() => {
              setDestroyed(false);
            }, 0);
            changeUrl(activeSegmentForUrl);
          }}
          options={optionsDom}
        />
        {getIfShowSourceExplanation(mainSegment) && (
          <div className="dbi_pcconsole_source_explanation-div">
            <SourceExplanation
              textValue={'dbi_pcconsole_source_explanation'}
              handleClickSourceState={handleClickSourceTips}
              openSource={openSource}
              isNeedLeft={false}
            />
          </div>
        )}
      </div>

      {openSource && getIfShowSourceExplanation(mainSegment) && (
        <SummaryCard isSourceTips={true} openSource={openSource} />
      )}

      {/* Famitsu/Japan Sales is temporarily unavailable.
          Restore by replacing the newzooMetrics branch below with:
          destroyed ? null : mainSegment == 'japanSales' ? (
            <JapanSales
              {...props}
              downloadModalSize={844}
              pageId={`${mainSegment}—${subSegment}`}
              tabType={tabType}
              loading={loading}
              setLoading={setLoading}
              mainSegment={mainSegment}
              subSegment={subSegment}
              gsdDevicesFlatten={gsdDevicesFlatten}
              gsdSegments={gsdSegments}
            />
          ) : mainSegment == 'newzooMetrics' ? (
      */}
      {destroyed ? null : mainSegment == 'newzooMetrics' ? (
        <NewzooMetrics
          {...props}
          downloadModalSize={844}
          pageId={`${mainSegment}—${subSegment}`}
          tabType={tabType}
          loading={loading}
          setLoading={setLoading}
          mainSegment={mainSegment}
          subSegment={subSegment}
          gsdDevicesFlatten={gsdDevicesFlatten}
          gsdSegments={gsdSegments}
          filterLeftComp={renderSubSegment(mainSegment)}
          getRadioOptionsTips={getRadioOptionsTips}
        />
      ) : (
        // digitalRevenue ,  physicalRevenue,
        <PCUPhysicalDigitalComp
          {...props}
          downloadModalSize={844}
          pageId={mainSegment}
          tabType={tabType}
          loading={loading}
          setLoading={setLoading}
          mainSegment={mainSegment}
          subSegment={subSegment}
          gsdDevicesFlatten={gsdDevicesFlatten}
          gsdOptionsLoading={gsdOptionsLoading}
          gsdDeviceOptions={gsdDevicesFlatten}
          gsdSegmentOptions={gsdSegments}
          gsdSegments={gsdSegments}
          getRadioOptionsTips={getRadioOptionsTips}
        />
      )}
    </div>
  );
}

connect((state: any) => {
  return {
    topchartsState: state[DBI_TOPCHARTS],
  };
})(ConsoleStats);
